import { useMemo } from 'react';
import { useFilterOptions } from './useFilterOptions';
import { useFilters } from '@retail/products/hooks';
import { searchFilters, SearchFilters, SelectedFilters } from '@retail/products/utils';

export const useSearchFilters = () => {
  const { filters, setFilters, resetFilters } = useFilters<SearchFilters>(searchFilters);

  const { suppliers, discountGroups, productGroupHierarchy, productGroups } = useFilterOptions({
    selectedSupplierNumbers: filters.supplierNumbers,
  });

  const hasActiveFilters = useMemo(
    () =>
      !!filters.supplierNumbers?.length ||
      !!filters.productGroupNumbers?.length ||
      (!!filters.supplierNumbers?.length && !!filters.discountGroupCodes?.length) ||
      !!filters.searchQuery,
    [
      filters.discountGroupCodes?.length,
      filters.productGroupNumbers?.length,
      filters.supplierNumbers?.length,
      filters.searchQuery,
    ]
  );

  return useMemo(
    () => ({
      hasActiveFilters,
      filterOptions: {
        suppliers,
        productGroups,
        productGroupHierarchy,
        discountGroups,
      },
      filters: filters satisfies SelectedFilters<SearchFilters>,
      setFilters,
      resetFilters,
    }),
    [
      hasActiveFilters,
      suppliers,
      productGroups,
      productGroupHierarchy,
      discountGroups,
      filters,
      setFilters,
      resetFilters,
    ]
  );
};
